import { ChangeDetectionStrategy, Component, inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Header } from './shared/ui/header/header';
import { Footer } from './shared/ui/footer/footer';
import { AnalyticsService } from './core/services/analytics.service';

const HEADER_OFFSET = 73; // --header-height 57px + 16px breathing room

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly _analytics = inject(AnalyticsService);

  constructor() {
    if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
    const router = inject(Router);
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    // Registrar iconos locales (Simple Icons) para usar con svgIcon
    iconRegistry.addSvgIcon('twitter', sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/twitter.svg'));
    iconRegistry.addSvgIcon('linkedin', sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/linkedin.svg'));

    router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        const fragment = router.parseUrl((e as NavigationEnd).urlAfterRedirects).fragment;
        if (fragment) {
          setTimeout(() => {
            const el = document.getElementById(fragment);
            if (!el) return;
            const top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
            window.scrollTo({ top, behavior: 'smooth' });
          }, 150);
        } else {
          window.scrollTo({ top: 0, behavior: 'instant' });
        }
      });
  }
}
